import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { APP_THEME } from '../theme';

const AppHeader: React.FC = () => {
  const navigate = useNavigate();
  const { user, openAuthDialog, logOut } = useAuth();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: { xs: '56px', sm: '75px' },
        bgcolor: 'white',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 2, sm: 4 },
      }}
    >
      <Box
        onClick={() => navigate('/')}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', cursor: 'pointer' }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: APP_THEME.colors.primary,
            fontWeight: 700,
            letterSpacing: '-0.5px',
            fontSize: { xs: '1.75rem', sm: '2.8rem' },
            lineHeight: { xs: 1, sm: 0.9 },
            m: 0,
            p: 0,
          }}
        >
          WTG!
        </Typography>
        <Typography
          variant="caption"
          component="p"
          sx={{
            color: APP_THEME.colors.primary,
            fontWeight: 400,
            letterSpacing: '0.2px',
            fontSize: { xs: '0.6rem', sm: '1.0rem' },
            lineHeight: 0.8,
            mt: { xs: 0, sm: '-0.1rem' },
            display: { xs: 'none', sm: 'block' },
          }}
        >
          walking tour generator
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 } }}>
        {user ? (
          <>
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                borderColor: APP_THEME.colors.secondary,
                color: APP_THEME.colors.secondary,
                px: { xs: 1.5, sm: 2.5 },
                fontSize: { xs: '0.8rem', sm: '0.95rem' },
                '&:hover': {
                  borderColor: '#45b8b0',
                  bgcolor: `${APP_THEME.colors.secondary}11`,
                },
              }}
            >
              Dashboard
            </Button>
            <Button
              onClick={() => logOut()}
              variant="contained"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                bgcolor: APP_THEME.colors.primary,
                px: { xs: 1.5, sm: 2.5 },
                fontSize: { xs: '0.8rem', sm: '0.95rem' },
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#ff5252',
                  boxShadow: 'none',
                },
              }}
            >
              Log Out
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={() => openAuthDialog('login')}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                borderColor: APP_THEME.colors.secondary,
                color: APP_THEME.colors.secondary,
                px: { xs: 1.5, sm: 2.5 },
                fontSize: { xs: '0.8rem', sm: '0.95rem' },
                '&:hover': {
                  borderColor: '#45b8b0',
                  bgcolor: `${APP_THEME.colors.secondary}11`,
                },
              }}
            >
              Log In
            </Button>
            <Button
              onClick={() => openAuthDialog('signup')}
              variant="contained"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                bgcolor: APP_THEME.colors.primary,
                px: { xs: 1.5, sm: 2.5 },
                fontSize: { xs: '0.8rem', sm: '0.95rem' },
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#ff5252',
                  boxShadow: 'none',
                },
              }}
            >
              Sign Up
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default AppHeader;
